import React from 'react';
import { Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import { IconEmptyGift } from '../../../shared';
import { useTranslation } from 'react-i18next';

const EmptyCouponsAndPromoCodes = () => {
  const { t } = useTranslation('profile');

  return (
    <div className={'flex flex-col flex-1 justify-center items-center gap-2'}>
      <IconEmptyGift />
      <Typography variant={TypographyVariantsEnum.Text20Semi} align={'center'}>
        {t('discounts.empty.title')}
      </Typography>
      <Typography variant={TypographyVariantsEnum.Text14Regular} opacity={50} align={'center'}>
        {t('discounts.empty.description')}
      </Typography>
    </div>
  );
};

export default EmptyCouponsAndPromoCodes;
